import "./AnswerContactMessage.scss";
import Button from "../../../Components/Button/Button";
import { TextField } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import newRequest from "../../../Utils/newRequest";
import { showErrorMessage } from "../../../Utils/showErrorMessage";
import Loader from "../../../Components/Loader/Loader";
import { message } from "antd";

const AnswerContactMessage = () => {
  const location = useLocation();
  const studentMessage = location.state;
  const [loading, setLoading] = useState(false);
  const [replay, setReplay] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await newRequest.put(`/contact_us/${studentMessage?.id}`, {
        reply: replay,
      });
      message.success("تم الرد بنجاح");
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setReplay("");
      setLoading(false);
    }
  };

  return (
    <div className="create">
      <div className="container">
        <h4 className="title">الرد علي البريد الالكتروني</h4>
        {loading ? (
          <Loader />
        ) : (
          <form action="" onSubmit={handleSubmit}>
            <div className="control-group">
              <div className="form-control">
                <label htmlFor="name">محتوي السؤال</label>
                <textarea
                  name=""
                  id=""
                  value={studentMessage?.message}
                  disabled
                  onChange={(e) => setReplay(e.target.value)}
                />
              </div>
            </div>

            <div className="control-group">
              <div className="form-control">
                <label className="form-label" htmlFor="name">
                  البريد الالكتروني المرسل اليه
                </label>
                <TextField
                  required
                  fullWidth
                  id="fullWidth"
                  value={studentMessage?.email}
                  className="form-input"
                />
              </div>
            </div>

            <div className="control-group">
              <div className="form-control">
                <label htmlFor="name">الرد علي السؤال</label>
                <textarea
                  name=""
                  id=""
                  value={replay}
                  required
                  onChange={(e) => setReplay(e.target.value)}
                />
              </div>
            </div>

            <div className="form-actions">
              <Button text="ارسال" size="large" variant="fill" />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AnswerContactMessage;
